const CSV_CACHE_KEY = 'accountCSV';
const CSV_CACHE_FILE_KEY = 'accountCSVFileName';
const CSV_CACHE_UPDATED_AT_KEY = 'accountCSVUpdatedAt';

const hasLocalStorage = () => {
  try {
    return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
  } catch {
    return false;
  }
};

export const readCachedCSV = () => {
  if (!hasLocalStorage()) return null;
  const csvText = window.localStorage.getItem(CSV_CACHE_KEY);
  if (!csvText) return null;

  return {
    csv_text: csvText,
    file_name: window.localStorage.getItem(CSV_CACHE_FILE_KEY) || 'account.csv',
    uploaded_at: window.localStorage.getItem(CSV_CACHE_UPDATED_AT_KEY) || null,
  };
};

export const writeCachedCSV = (csvText, fileName = 'account.csv', uploadedAt = new Date().toISOString()) => {
  if (!csvText || !hasLocalStorage()) return;
  window.localStorage.setItem(CSV_CACHE_KEY, csvText);
  window.localStorage.setItem(CSV_CACHE_FILE_KEY, fileName || 'account.csv');
  window.localStorage.setItem(CSV_CACHE_UPDATED_AT_KEY, uploadedAt || new Date().toISOString());
};

export const clearCachedCSV = () => {
  if (!hasLocalStorage()) return;
  window.localStorage.removeItem(CSV_CACHE_KEY);
  window.localStorage.removeItem(CSV_CACHE_FILE_KEY);
  window.localStorage.removeItem(CSV_CACHE_UPDATED_AT_KEY);
};

const parseTimestamp = (value) => {
  if (!value) return null;
  const parsed = Date.parse(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const choosePreferredCSV = (localCSV, cloudCSV) => {
  if (localCSV?.csv_text && !cloudCSV?.csv_text) return localCSV;
  if (cloudCSV?.csv_text && !localCSV?.csv_text) return cloudCSV;
  if (!localCSV?.csv_text && !cloudCSV?.csv_text) return null;

  const localTs = parseTimestamp(localCSV?.uploaded_at);
  const cloudTs = parseTimestamp(cloudCSV?.uploaded_at);

  // Bias toward the current browser cache when timing metadata is missing.
  if (!localTs) return localCSV;
  if (!cloudTs) return localCSV;

  return cloudTs > localTs ? cloudCSV : localCSV;
};
